module.exports = __webpack_public_path__ + "7m8l7TlFO-S3VkhHuR0at_ZraR2Tg8w2lzm7kLNL0-w.7237c876dc783a22bf28.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/7m8l7TlFO-S3VkhHuR0at_ZraR2Tg8w2lzm7kLNL0-w.woff2
// module id = ../../../../../src/assets/fonts/font-google/7m8l7TlFO-S3VkhHuR0at_ZraR2Tg8w2lzm7kLNL0-w.woff2
// module chunks = 40